import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { AxiosError } from 'axios'
import { getMeFn } from '../api/auth'
import Sidebar from '../components/sidebar'
import Toast from '../components/toast'
import useStore from '../store'
import { logger } from '../utils/logger'

export default function AuthLayout(): JSX.Element {
  const setAuthUser = useStore((state) => state.setAuthUser)
  const setRequestLoading = useStore((state) => state.setRequestLoading)
  const setCredentials = useStore((state) => state.setCredentials)
  const userToken = useStore((state) => state.userCredentials.token)
  const addToastMessage = useStore((state) => state.addMessage)
  const navigate = useNavigate()

  useQuery({
    queryKey: ['getMe'],
    queryFn: getMeFn,
    enabled: !!userToken,
    onSuccess(data) {
      setAuthUser(data)
      setRequestLoading(false)
      logger.setUser(data.id.toString(), data.name, data.email)
      logger.setCustomAttributes({
        userId: data.id.toString(),
        userName: data.name,
        userEmail: data.email
      })
    },
    onError(error: Error) {
      setRequestLoading(false)
      setCredentials({ token: '' })
      if (error instanceof AxiosError && error.code === 'ERR_BAD_REQUEST') {
        addToastMessage({
          type: 'warning',
          text: 'Sesión expirada, por favor inicie sesión nuevamente',
          id: Math.random().toString(36).substring(2, 9)
        })
        return
      }
      if (error.message) {
        addToastMessage({
          type: 'error',
          text: error.message,
          id: Math.random().toString(36).substring(2, 9)
        })
      } else {
        addToastMessage({
          type: 'error',
          text: 'Error desconocido ocurrido al obtener los datos del usuario',
          id: Math.random().toString(36).substring(2, 9)
        })
      }
    },
    refetchOnWindowFocus: false,
    retry: false
  })

  useEffect(() => {
    if (!userToken) {
      navigate('/login', { replace: true })
    }
  }, [userToken, navigate])

  return !userToken ? (
    <>LOADING</>
  ) : (
    <>
      <Toast />
      <Sidebar>
        <Outlet />
      </Sidebar>
    </>
  )
}
